import { call, ForkEffect, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { PayloadAction } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { paymentActions } from './paymentSlice';
import { getPaymentByOrganizationId } from '../../api/paymentApi';
import { createPortalSession, retryPayment } from '../../api/stripeApi';
import { toastStyles } from '../../utils/styles';
import { invoiceActions } from '../invoice/invoiceSlice';

function* watchGetPaymentsByOrganizationId(action: { payload: string }) {
  try {
    yield put(paymentActions.setComponentStatus({ getPaymentsLoading: true }));
    const res: AxiosResponse = yield call(getPaymentByOrganizationId, action.payload);
    yield put(paymentActions.setComponentStatus({ getPaymentsLoading: false }));
    yield put(paymentActions.fetchPaymentsByOrganizationIdSuccess(res.data));
  } catch (err: any) {
    yield put(paymentActions.setComponentStatus({ getPaymentsLoading: false }));
    yield put(paymentActions.fetchPaymentsByOrganizationIdFailure(err.message || 'Failed to fetch payment data'));
  }
}

function* watchRetryPayment(action: PayloadAction<{ stripeAccountId: string; amount: number; paymentId: string }>) {
  try {
    yield call(retryPayment, action.payload.amount);
    yield put(invoiceActions.getInvoiceByPaymentIdAsync(action.payload.paymentId));
    yield put(paymentActions.retryPaymentSuccess());
    toast.success('Payment Successful', toastStyles.success);
  } catch (err) {
    toast.error('Payment Unsuccessful', toastStyles.error);
    yield put(paymentActions.setPaymentError('Payment is unsuccessful'));
  }
}

function* watchCreatePortalSession(action: PayloadAction<{ stripeAccountId: string; returnUrl: string }>) {
  try {
    const res: AxiosResponse = yield call(
      createPortalSession,
      action.payload.stripeAccountId,
      action.payload.returnUrl,
    );
    yield put(paymentActions.setPortalUrl(res.data.url));
  } catch (err) {
    yield put(paymentActions.setPortalUrl(null));
  }
}

export function* watchPaymentSagas(): Generator<ForkEffect, void> {
  yield takeLatest(paymentActions.getPaymentsByOrganizationIdAsync, watchGetPaymentsByOrganizationId);
  yield takeLatest(paymentActions.retryPaymentAsync, watchRetryPayment);
  yield takeLatest(paymentActions.createPortalSessionAsync.type, watchCreatePortalSession);
}

const paymentSagas = watchPaymentSagas;
export default paymentSagas;
